import { Box, BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';
import { rgba } from 'polished';

import { AddIcon } from '@treams/treams-icons';

const Container = styled(Flex)`
	border-radius: 5px;
	border: 1px dashed ${(props) => props.theme.colors.lightBlue};
	font-size: 16px;
	color: ${(props) => props.theme.colors.slateBlue};
	align-items: center;
	justify-content: center;
	cursor: pointer;

	svg {
		display: block;
		width: 24px;
		height: 24px;

		* {
			fill: ${(props) => props.theme.colors.slateBlue};
		}
	}

	&:hover {
		background: ${(props) => rgba(props.theme.colors.lightBlue, 0.25)};
		border-color: transparent;

		&:active {
			background: ${(props) => rgba(props.theme.colors.lightBlue, 0.5)};
		}
	}
`;

const Icon = styled(Box)`
	width: 32px;
	height: 32px;
	background: ${(props) => props.theme.colors.lightBlue};
	padding: 4px;
	border-radius: 16px;
`;

export function PlaceholderCard(props: BoxProps & { title?: string; onClick?: () => void }) {
	return (
		<Container {...props}>
			<Icon flexShrink={0} flexGrow={0}>
				<AddIcon />
			</Icon>
			{props.title && <Box ml={2}>{props.title}</Box>}
		</Container>
	);
}
